import { render, staticRenderFns } from "./ModerationQueue.vue?vue&type=template&id=5ce902fb&"
import script from "./ModerationQueue.vue?vue&type=script&lang=js&"
export * from "./ModerationQueue.vue?vue&type=script&lang=js&"
import style0 from "./ModerationQueue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports